// extracted by mini-css-extract-plugin
module.exports = {"description":"ProductDetail-module--description--1kcCj","image":"ProductDetail-module--image--1q2_1"};